import { render } from "./InfoCreditoDaGestire.vue?vue&type=template&id=281c442a&scoped=true"
import script from "./InfoCreditoDaGestire.vue?vue&type=script&lang=js"
export * from "./InfoCreditoDaGestire.vue?vue&type=script&lang=js"

import "./InfoCreditoDaGestire.vue?vue&type=style&index=0&id=281c442a&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281c442a"]])

export default __exports__